/**
 * This class handles general modifications to ACF fields.
 *
 */
class generalACFModifications {
	constructor() {
		this.removeSeconds();
		this.restrictPastDates();
	}

	/**
	 * Removes the seconds from the datetime picker.
	 */
	removeSeconds = () => {
		acf.add_filter( 'date_time_picker_args', function( args, $field ) { // eslint-disable-line no-unused-vars
			args.units = [ 'hour', 'minute' ];
			args.showSecond = false;
			return args;
		} );
	};

	/**
	 * Restricts end date to dates after start date.
	 */
	restrictPastDates = () => {
		acf.add_filter( 'date_time_picker_args', function( args, field ) { // eslint-disable-line no-unused-vars
			const fieldKey = field[ 0 ].dataset.key;

			// Set restriction on start date.
			if ( fieldKey === 'field_639c42807ec90' ) {
				args.onSelect = function( date ) {
					// Set end date field min date.
					jQuery( ".af-field[data-key='field_639c43be7ec92'] .input" ).datepicker( 'option', 'minDate', date );
				};

				// Set up the maxDate for the start date field when opening it based on the value of the end date field if there is one.
				args.beforeShow = function( input, inst ) { // eslint-disable-line no-unused-vars
					const theDate = jQuery( ".af-field[data-key='field_639c43be7ec92'] .input" ).datepicker( 'getDate' );
					if ( theDate ) {
						const dateObject = new Date( theDate );
						return {
							maxDate: dateObject,
						};
					}
				};
			}

			// Set restriction on end date. Or more specifically, when the end date is selected, update the start dates datepicker with a new max date.
			if ( fieldKey === 'field_639c43be7ec92' ) {
				args.onSelect = function( date ) {
					// Set start date field max date.
					jQuery( ".af-field[data-key='field_639c42807ec90'] .input" ).datepicker( 'option', 'maxDate', date );
				};

				// Set up the minDate for the end date field when opening it based on the value of the start date field if there is one.
				args.beforeShow = function( input, inst ) { // eslint-disable-line no-unused-vars
					const theDate = jQuery( ".af-field[data-key='field_639c42807ec90'] .input" ).datepicker( 'getDate' );
					if ( theDate ) {
						const dateObject = new Date( theDate );
						return {
							minDate: dateObject,
						};
					}
				};
			}

			return args;
		} );
	};
}

export default generalACFModifications;
